import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";
import { ALLOWED_MODULES } from "../../constants/enums";

// Lazy routes
const MasterQuickReplyTemplateListV2 = Loadable(
  lazy(() =>
    import("./MasterQuickReplyTemplateListV2").then(
      ({ MasterQuickReplyTemplateListV2 }) => ({
        default: MasterQuickReplyTemplateListV2,
      }),
    ),
  ),
);

const ManageMasterQuickReplyTemplate = Loadable(
  lazy(() =>
    import("./ManageMasterQuickReplyTemplate").then(
      ({ ManageMasterQuickReplyTemplate }) => ({
        default: ManageMasterQuickReplyTemplate,
      }),
    ),
  ),
);

export const masterQuickReplyTemplateRoutes = [
  {
    path: "/master-quick-reply-templates",
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[ALLOWED_MODULES.MASTER_QUICK_REPLY_TEMPLATE]}>
        <MasterQuickReplyTemplateListV2 />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/master-quick-reply-templates/manage",
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[ALLOWED_MODULES.MASTER_QUICK_REPLY_TEMPLATE]}>
        <ManageMasterQuickReplyTemplate />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/master-quick-reply-templates/manage/:masterQuickReplyTemplateName",
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[ALLOWED_MODULES.MASTER_QUICK_REPLY_TEMPLATE]}>
        <ManageMasterQuickReplyTemplate />
      </AuthorizedRoute>
    ),
  },
];
